<template>
  <b-modal id="forget_secpassword" centered :title="$t('forget_secpassword')" hide-footer>
    <div>
        <b-form @submit.prevent="sendOTP">
            <div v-for="value, name in form" :key="name" class="mb-4">
                <FormInput :name="name" :value="value" @updateInput="(n) => form[name] = n" :noActions="true" :readonly=" name == 'email'" :placeholder="$t(placeholders[name])"></FormInput>
                <div class="text-left">
                    <span v-if="name === 'new_sec_password'" class="text-dangerHint">
                        {{ $t('passwordHint') }}
                    </span>
                    <span v-else-if="name === 'confirm_new_secpwd'" class="text-dangerHint">
                        {{ $t('secpasswordHint') }}
                    </span>
                </div>
                <div class="mt-1 ml-auto" v-if="name == 'otp'">
                    <b-button variant="primary" class="d-block ml-auto text-14 btn-small" @click="getOTP"
                        :disabled="timecount < 60">{{ timecount < 60 ? `${$t('resend_in')} ${timecount}` : $t('send_otp')
                            }}</b-button>
                </div>
            </div>
            <div class="text-center mt-2">
                <b-button :variant="isFormObjectEmptyExcept(form, ['email']) ? 'light' : 'primary'" class="btn-small text-14" type="submit" :disabled="isFormObjectEmptyExcept(form, ['email'])">
                    {{ $t('reset_password') }}
                </b-button>
            </div>
        </b-form>
    </div>
  </b-modal>
</template>

<script>
import {
  requestOTP,
  checkOTP,
  forgetSecPassword,
} from "@/system/request/api/api";
import FormInput from '@/components/formInput.vue';
import { handleError } from "@/system/request/handleRes";
export default {
  components: {
    FormInput
  },
  data() {
    return {
        form: {
            email: '',
            otp: '',
            new_sec_password: '',
            confirm_new_secpwd: '',
        },
        placeholders: {
            otp: 'otp_placeholder',
            new_sec_password: 'new_sec_password_placeholder',
            confirm_new_secpwd: 'confirm_new_secpwd_placeholder',
        },
        myVar: null,
        timecount: 60,
    };
  },
  watch: {
    '$root.userInfo.email'(newVal) {
      if (newVal) this.form.email = newVal;
    }
  },
  methods: {
    getInfo() {

      var info = JSON.parse(localStorage.getItem('info'));

      this.email = info.email;
    },
    sendOTP() {
      let formData = new FormData();
      var self = this;
      formData.append("otp", this.form.otp);
      var result = checkOTP(formData);
      self.isLoading = true;

      result
        .then(function (value) {
          console.log(value.data);
          if (value.data.code == 0 || value.data.code === "0") {
            self.$root.makeToast("success", self.$t(value.data.message));
            self.submitForm();
          } else {
            self.$root.makeToast("danger", self.$t(value.data.message));
          }
          self.sending = false;
          self.isLoading = false;
        })
        .catch(function (error) {
          self.$root.makeToast("warning", self.$t(handleError(error)));
          self.sending = false;
          self.isLoading = false;
        });
    },
    submitForm() {
      const pwd = this.form.new_sec_password;

      if (pwd.length < 8 || !/\d/.test(pwd)) {
        this.$root.makeToast("danger", this.$t('passwordHint'));
        return;
      }

      if (pwd !== this.form.confirm_new_secpwd) {
        this.$root.makeToast("danger", this.$t('passwordHint2'));
        return;
      }
      let formData = new FormData();
      var self = this;
      self.$root.isLoading = true;
      formData.append("otp", this.form.otp);
      formData.append("password", this.form.new_sec_password);
      formData.append("password_confirmation", this.form.confirm_new_secpwd);
      var result = forgetSecPassword(formData);

      result
        .then(function (value) {
          console.log(value.data);
          if (value.data.error_code == 0) {
            self.$root.makeToast("success", self.$t('sec_password_updated'));
            self.$bvModal.hide('forget_secpassword');
            self.form.otp = '';
            self.form.new_sec_password = '';
            self.form.confirm_new_secpwd = '';
          } else {
            self.$root.makeToast("danger", self.$t(value.data.message));
          }
          self.$root.isLoading = false;
        })
        .catch(function (error) {
          self.$root.makeToast("warning", self.$t(handleError(error)));
          self.$root.isLoading = false;
        });
      
    },
    getOTP() {
      if (this.form.email.length == 0) {
        this.$root.makeToast("danger", this.$t("emailEmpty"));
      } else {
        this.$root.isLoading = true;
        let formData = new FormData();
        var self = this;

        formData.append("otp_type", "email");
        // formData.append("email", this.form.email);
        var result = requestOTP(formData);

        result
          .then(function (value) {
            console.log(value.data);
            if (value.data.code.toString() == '0') {
              self.$root.makeToast("success", self.$t("otp_sent"));
              self.myVar = setInterval(() => {
                self.timecount -= 1;
                if (self.timecount == 0) {
                    self.timecount = 60;
                    clearInterval(self.myVar);
                }
            }, 1000);
            } else {
              self.$root.makeToast("danger", self.$t(value.data.message));
            }
             self.$root.isLoading = false;
          })
          .catch(function (error) {
            self.$root.makeToast("warning", self.$t(handleError(error)));
            self.$root.isLoading = false;
          });
      }
    },
  },

  created() {
    if (this.$root.userInfo && this.$root.userInfo.email) {
      this.form.email = this.$root.userInfo.email;
    }
  }
};
</script>

